import { BusniessOfficeNote } from "../../../../data-model/busniessOfficeNote";
import { MedicalPaOrder } from "../../../../data-model/medicalPaOrdersModel";
import { LocalStorageKeys } from "../../../../enums/localStorageKeys";
import { getItemFromLocalStorage } from "../../../../utils/localStorageHelper";

/**
 * Converts BO comments from local storage into write-back notes format
 */
const createWriteBackNotes = (postComments: any[]): BusniessOfficeNote[] => {
  const firstPostComment = postComments[0];

  return firstPostComment.comments.map((comment) => ({
    report_identifier: comment?.id ?? "",
    template_text: comment?.writeBackComment ?? "",
    report_status: comment?.boStatus ?? "",
  }));
};

/**
 * Merges write-back notes with existing reports
 */
const mergeReportsWithWriteBackNotes = (
  originalReports: any[],
  writeBackNotes: BusniessOfficeNote[],
) => {
  return originalReports.map((report) => {
    const matchingWriteBackNote = writeBackNotes.find(
      (note) => note.report_identifier === report.report_identifier,
    );
    return { ...report, ...matchingWriteBackNote };
  });
};

/**
 * Generates updated report data by merging BO comments from local storage
 * with existing medical PA order reports
 */
export const generateWriteBackDataForManualUpdate = (
  medicalPaOrder?: MedicalPaOrder,
) => {
  const boComments = getItemFromLocalStorage(
    `${LocalStorageKeys.BO_COMMENTS}_${medicalPaOrder?.id}`,
  );

  if (!boComments || boComments.length === 0) {
    return undefined;
  }

  const postComments = boComments.filter((comment) => comment.type === "post");

  if (postComments.length === 0) {
    return undefined;
  }

  const writeBackNotes = createWriteBackNotes(postComments);
  const originalReports = medicalPaOrder?.auth_on_file?.reports ?? [];

  return mergeReportsWithWriteBackNotes(originalReports, writeBackNotes);
};
